var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Telegram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.0011 4.33398C18.0504 4.33398 13.3025 6.30065 9.80181 9.80132C6.30113 13.302 4.33447 18.0499 4.33447 23.0006C4.33447 27.9514 6.30113 32.6993 9.80181 36.2C13.3025 39.7007 18.0504 41.6673 23.0011 41.6673C27.9518 41.6673 32.6998 39.7007 36.2005 36.2C39.7011 32.6993 41.6678 27.9514 41.6678 23.0006C41.6678 18.0499 39.7011 13.302 36.2005 9.80132C32.6998 6.30065 27.9518 4.33398 23.0011 4.33398Z",
    fill: "#29B6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.2879 14.5998L28.7916 32.4508C28.7916 32.4508 28.6414 33.2665 27.6296 33.2665C27.092 33.2665 26.8148 33.0108 26.8148 33.0108L19.2418 26.7266L15.5364 24.859L10.7811 23.5944C10.7811 23.5944 9.93457 23.3498 9.93457 22.6498C9.93457 22.0665 10.8054 21.7884 10.8054 21.7884L30.7003 13.8849C30.7003 13.8849 31.3079 13.6656 31.7512 13.6665C32.0238 13.6665 32.3346 13.7832 32.3346 14.1332C32.3346 14.3665 32.2879 14.5998 32.2879 14.5998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.0671 29.072L18.8695 32.2211C18.8695 32.2211 18.7305 32.3284 18.5447 32.3331C18.4803 32.3349 18.4113 32.3247 18.3403 32.2929L19.2401 26.7256L22.0671 29.072Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.5052 17.5827C28.3475 17.3774 28.0563 17.3401 27.8509 17.4959L15.5347 24.8665C15.5347 24.8665 17.5003 30.3657 17.7999 31.3177C18.1004 32.2706 18.3412 32.293 18.3412 32.293L19.2409 26.7257L28.4175 18.2361C28.6228 18.0802 28.6611 17.7881 28.5052 17.5827Z",
    fill: "#CFD8DC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.51f28051eb2ceba04306b2f75489645d.svg";
export { ForwardRef as ReactComponent };